import React from 'react';
import { SubscriptionService } from '../components/LearnEarn/SubscriptionService';

export default function SubscriptionServicePage() {
  return <SubscriptionService />;
}